import React from 'react'
import { Grid } from '@the-platform-group/component-library/Layout'
import { Chip } from '@the-platform-group/component-library'
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  FileCopy as FileCopyIcon,
} from '@the-platform-group/component-library/Icons'
import useContactLookupState from '../hooks/useContactLookupState'
import { useNotification } from 'components/Notification'
import EmailGrader from './EmailGrader'
import PhoneGrader from './PhoneGrader'

/**
 * Contact Information Component
 * @param {Object} row - The row data
 * @returns {React.Component} - The ContactInformation component that displays email and phone number
 */
const ContactInformation = ({ row }) => {
  const { createNotification } = useNotification()
  const { hasLookupData, lookupData } = useContactLookupState(row.id)

  // Use lookup data if available, otherwise use search data
  const displayData = lookupData || row
  const emailObject = displayData.emails?.[0]
  const phoneObject = displayData.phones?.[0]
  const email = emailObject?.email
  const phone = phoneObject?.number
  const emailGrade = emailObject?.grade
  const isPhoneTypeDefined = phoneObject?.type !== null

  const handleCopyData = (section, data) => {
    navigator?.clipboard.writeText(data)
    createNotification({
      message: `${section} copied to clipboard`,
      variant: 'success',
    })
  }

  return (
    <Grid container spacing={0.5} direction="column">
      {email && (
        <Grid item container alignItems="center" spacing={0.5}>
          <Grid item xs={emailGrade ? 10 : 12}>
            <Chip
              label={email}
              icon={<EmailIcon />}
              variant={hasLookupData ? 'outlined' : 'default'}
              size="small"
              sx={{
                justifyContent: 'flex-start',
                px: 0.5,
                width: '100%',
              }}
              {...(hasLookupData && {
                deleteIcon: <FileCopyIcon sx={{ pl: 0.5 }} />,
                onDelete: () => {
                  handleCopyData('Email', email)
                },
              })}
            />
          </Grid>
          {emailGrade && (
            <Grid item xs={2}>
              <EmailGrader email={emailObject} />
            </Grid>
          )}
        </Grid>
      )}
      {phone && (
        <Grid item container alignItems="center" spacing={0.5}>
          <Grid item xs={isPhoneTypeDefined ? 10 : 12}>
            <Chip
              label={phone}
              icon={<PhoneIcon />}
              variant={hasLookupData ? 'outlined' : 'default'}
              size="small"
              sx={{
                justifyContent: 'flex-start',
                px: 0.5,
                width: '100%',
              }}
              {...(hasLookupData && {
                deleteIcon: <FileCopyIcon sx={{ pl: 0.5 }} />,
                onDelete: () => {
                  handleCopyData('Phone', phone)
                },
              })}
            />
          </Grid>
          {isPhoneTypeDefined && (
            <Grid item xs={2}>
              <PhoneGrader phone={phoneObject} />
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  )
}
export default ContactInformation
